export class HighlightError extends Error {
  constructor(
    message: string,
    public cause?: unknown,
  ) {
    super(message);
    this.name = "HighlightError";
  }
}

export class HighlightFetchError extends HighlightError {
  constructor(
    message: string,
    cause?: unknown,
    /** HTTP status of the failed response, when one was received. */
    public status?: number,
  ) {
    super(message, cause);
    this.name = "HighlightFetchError";
  }
}

export class HighlightValidationError extends HighlightError {
  constructor(
    message: string,
    public validationErrors?: unknown,
  ) {
    super(message);
    this.name = "HighlightValidationError";
  }
}
